import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const product: LocalePerProduct = {
  livejasmin: {
    ...defineMessages({
      title: {
        id: 'pages.bestOf.topModels.product.livejasmin.title',
        defaultMessage: 'Top Models',
      },
      header: {
        id: 'pages.bestOf.topModels.product.livejasmin.header',
        defaultMessage: 'Top {numTopModels} Models',
      },
      subheader: {
        id: 'pages.bestOf.topModels.product.livejasmin.subheader',
        defaultMessage: 'Reach the Top {numTopModels}, enjoy extra exposure, and <b>boost your traffic!</b>',
      },
    }),
  },
  oranum: {
    ...defineMessages({
      title: {
        id: 'pages.bestOf.topModels.product.oranum.title',
        defaultMessage: 'Leaderboard',
      },
      header: {
        id: 'pages.bestOf.topModels.product.oranum.header',
        defaultMessage: 'Top Experts',
      },
      subheader: {
        id: 'pages.bestOf.topModels.product.oranum.subheader',
        defaultMessage:
          "We're giving up to <b>{monthlyAmount}</b> to our Top Experts every month! Connect with members to earn points and elevate your ranking!",
      },
    }),
  },
};

export default {
  pages: {
    bestOf: {
      topModels: {
        product,
        ...defineMessages({
          moreInfo: {
            id: 'pages.bestOf.topModels.moreInfo',
            defaultMessage: 'More Info',
          },
        }),
        moreInfoModal: {
          ...defineMessages({
            header: {
              id: 'pages.bestOf.topModels.moreInfoModal.header',
              defaultMessage: 'Top Experts Contest',
            },
            subheader: {
              id: 'pages.bestOf.topModels.moreInfoModal.subheader',
              defaultMessage: 'Rise in the rankings and win cash prizes!',
            },
            firstPlace: {
              id: 'pages.bestOf.topModels.moreInfoModal.firstPlace',
              defaultMessage: '1st Place',
            },
            secondPlace: {
              id: 'pages.bestOf.topModels.moreInfoModal.secondPlace',
              defaultMessage: '2nd Place',
            },
            thirdPlace: {
              id: 'pages.bestOf.topModels.moreInfoModal.thirdPlace',
              defaultMessage: '3rd Place',
            },
            randomGiveaways: {
              id: 'pages.bestOf.topModels.moreInfoModal.randomGiveaways',
              defaultMessage: '{numGiveaways} random giveaways',
            },
            mustHave: {
              id: 'pages.bestOf.topModels.moreInfoModal.mustHave',
              defaultMessage: '*Must have a min. of {minHours} hours online and {minEarnings} in earnings.',
            },
            paragraph1: {
              id: 'pages.bestOf.topModels.moreInfoModal.paragraph1',
              defaultMessage:
                "Our newest monthly contest is here to motivate you to stay active, engage with your members, and use all the site's available features.",
            },
            paragraph2: {
              id: 'pages.bestOf.topModels.moreInfoModal.paragraph2',
              defaultMessage:
                'Collect points through the end of the <b>month</b> to climb to Top Experts ranking and <b>win amazing prizes!</b>',
            },
            paragraph3: {
              id: 'pages.bestOf.topModels.moreInfoModal.paragraph3',
              defaultMessage:
                'Every dollar you make, every minute you <b>spend</b> online, and every message you reply to bring you closer to your cash prize!',
            },
            paragraph4: {
              id: 'pages.bestOf.topModels.moreInfoModal.paragraph4',
              defaultMessage:
                'Remember, <b>every dollar earned</b> increases your chances to win the random prize. The more you earn, the higher probability you will win a prize!',
            },
            footer: {
              id: 'pages.bestOf.topModels.moreInfoModal.footer',
              defaultMessage:
                'Connect with your members and support them through thick and thin to boost your earnings, climb to the top, <b>and win!</b>',
            },
            wiki: {
              id: 'pages.bestOf.topModels.moreInfoModal.wiki',
              defaultMessage: 'For more info check out the Wiki Page!',
            },
          }),
        },
        periodFilter: {
          ...defineMessages({
            monthly: {
              id: 'pages.bestOf.topModels.periodFilter.monthly',
              defaultMessage: 'Monthly',
            },
            weekly: {
              id: 'pages.bestOf.topModels.periodFilter.weekly',
              defaultMessage: 'Weekly',
            },
            daily: {
              id: 'pages.bestOf.topModels.periodFilter.daily',
              defaultMessage: 'Daily',
            },
          }),
        },
        pageTabs: {
          ...defineMessages({
            current: {
              id: 'pages.bestOf.topModels.pageTabs.current',
              defaultMessage: 'Current Contest',
            },
            lastMonth: {
              id: 'pages.bestOf.topModels.pageTabs.lastMonth',
              defaultMessage: "Last Month's Winners",
            },
          }),
        },
        ...defineMessages({
          points: {
            id: 'pages.bestOf.topModels.points',
            defaultMessage: '{points} points',
          },
          inCash: {
            id: 'pages.bestOf.topModels.inCash',
            defaultMessage: '{amount} in cash',
          },
          unavailable: {
            id: 'pages.bestOf.topModels.unavailable',
            defaultMessage: 'The leaderboard is currently unavailable. Please try again later.',
          },
        }),
      },
    },
  },
};
